define(['jquery', 'moment', 'moment-timezone'],
    function ($, moment, momentTimezone) {
        'use strict';

        window.EnsembleVideo = window.EnsembleVideo || {};

        /*
        Parameters:
            options
            - Hal options
        Description:
            Hal parser
        */
        window.EnsembleVideo.Hal = function (options) {
            this.rootUrl = options.rootUrl;
            this.setting = options.setting;
            this.institutionId = options.institutionId;

            this.brandingUrl = null;

            this.fallbackThumbnailUrl = null;

            this.brandingUrlPath = [
                { name: "ev:Brandings/Current", type: "link" },
                { name: "href", type: "property" }
            ];
            this.nextPagePath = [
                { name: "next", type: "link" },
                { name: "href", type: "property" }
            ];
            this.selfPath = [
                { name: "self", type: "link" },
                { name: "href", type: "property" }
            ];
            this.playlistNamePath = [
                { name: "ev:Playlists/Get", type: "embed" },
                { name: "name", type: "property" }
            ];
            this.playlistLogoPath = [
                { name: "ev:Playlists/Get", type: "embed" },
                { name: "logo", type: "property" }
            ];
            this.playlistPublishedCategoriesPath = [
                { name: "ev:Playlists/Get", type: "embed" },
                { name: "publishedCategories", type: "property" }
            ];
            this.quizThumbnailPath = [
                { name: "ev:Quizzes/Get", type: "embed" },
                { name: "ev:Contents/Get", type: "embed" },
                { name: "ev:Images/Thumbnail", type: "link" },
                { name: "href", type: "property" }
            ];
            this.contentThumbnailPath = [
                { name: "ev:Contents/Get", type: "embed" },
                { name: "ev:Images/Thumbnail", type: "link" },
                { name: "href", type: "property" }
            ];
            this.quizPluginPath = [
                { name: "ev:Quizzes/Get", type: "embed" },
                { name: "ev:QuizPlugin/Get", type: "link" },
                { name: "href", type: "property" }
            ];
            this.contentPluginPath = [
                { name: "ev:Contents/Get", type: "embed" },
                { name: "ev:Plugin/Get", type: "link" },
                { name: "href", type: "property" }
            ];
            this.quizLaunchPath = [
                { name: "ev:Quizzes/Get", type: "embed" },
                { name: "ev:QuizPlugin/Launch", type: "link" },
                { name: "href", type: "property" }
            ];
            this.contentLaunchPath = [
                { name: "ev:Contents/Get", type: "embed" },
                { name: "ev:Plugin/Launch", type: "link" },
                { name: "href", type: "property" }
            ];
            this.quizJavascriptPluginPath = [
                { name: "ev:Quizzes/Get", type: "embed" },
                { name: "ev:QuizPlugin/JavaScript", type: "link" },
                { name: "href", type: "property" }
            ];
            this.contentJavascriptPluginPath = [
                { name: "ev:Contents/Get", type: "embed" },
                { name: "ev:Plugin/JavaScript", type: "link" },
                { name: "href", type: "property" }
            ];
            this.quizViewsCountPath = [
                { name: "ev:Quizzes/Get", type: "embed" },
                { name: "ev:Contents/Get", type: "embed" },
                { name: "viewsCount", type: "property" }
            ];
            this.contentViewsCountPath = [
                { name: "ev:Contents/Get", type: "embed" },
                { name: "viewsCount", type: "property" }
            ];
            this.contentWorkflowTypePath = [
                { name: "ev:Contents/Get", type: "embed" },
                { name: "workflowType", type: "property" }
            ];
        };

        window.EnsembleVideo.Hal.prototype = {
            /*
            Description:
                Initializes plugin
            */
            initialize: function (callback) {
                var self = this;
                this.get(this.rootUrl, {}, function(data) {
                    self.brandingUrl = self.parseHalObject(data, self.brandingUrlPath, "");
                    self.getFallbackThumbnail(callback);
                });
            },
            get: function (url, parameters, successCallback, errorCallback, headers) {
                if (headers === undefined || headers === null)
                    headers = { 'Accept': "application/hal+json, application/json, */*; q=0.01" };

                $.ajax({
                    cache: false,
                    type: "get",
                    headers: headers,
                    url: url,
                    data: parameters,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data) {
                        if (successCallback !== undefined)
                            successCallback(data);
                    },
                    error: function (req, err) {
                        if (errorCallback !== undefined)
                            errorCallback(req, err);
                    }
                });
            },
            delete: function (url, successCallback, errorCallback) {
                $.ajax({
                    cache: false,
                    type: "delete",
                    headers: { 'Accept': "application/hal+json, application/json, */*; q=0.01" },
                    url: url,
                    success: function (data) {
                        if (successCallback !== undefined)
                            successCallback(data);
                    },
                    error: function (req, err) {
                        if (errorCallback !== undefined)
                            errorCallback(req, err);
                    }
                });
            },
            parseHalObject: function (object, paths, defaultValue) {
                var pathValue = null;
                $.each(paths, function (index, path) {
                    if (pathValue === null)
                        pathValue = object;

                    if (path.type === "embed") {
                        pathValue = pathValue._embedded[path.name];
                    }

                    if (path.type === "link") {
                        pathValue = pathValue._links[path.name];
                    }

                    if (path.type === "property") {
                        pathValue = pathValue[path.name];
                    }

                    if (pathValue === null || pathValue === undefined) {
                        pathValue = defaultValue;
                        return false;
                    }
                });

                return pathValue;
            },
            parsePublish: function (data) {
                var pluginUrl = "";
                var launchUrl = "";
                var viewsCount = "0";
                var thumbnailUrl = "";
                var javascriptPluginUrl = "";
                var isYoutube = false;

                if (data.isQuiz) {
                    pluginUrl = this.parseHalObject(data, this.quizPluginPath, "");
                    launchUrl = this.parseHalObject(data, this.quizLaunchPath, "");
                    thumbnailUrl = this.parseHalObject(data, this.quizThumbnailPath, this.fallbackThumbnailUrl);
                    javascriptPluginUrl = this.parseHalObject(data, this.quizJavascriptPluginPath, "");
                } else {
                    pluginUrl = this.parseHalObject(data, this.contentPluginPath, "");
                    launchUrl = this.parseHalObject(data, this.contentLaunchPath, "");
                    viewsCount = this.parseHalObject(data, this.contentViewsCountPath, "0");
                    thumbnailUrl = this.parseHalObject(data, this.contentThumbnailPath, this.fallbackThumbnailUrl);
                    javascriptPluginUrl = this.parseHalObject(data, this.contentJavascriptPluginPath, "");
                    isYoutube = (this.parseHalObject(data, this.contentWorkflowTypePath, "") === "YouTube");
                }

                return {
                    id: data.id,
                    isQuiz: data.isQuiz,
                    name: data.name,
                    dateProduced: this.convertToUserDateTime(data.dateProduced, this.setting.timeZone, this.setting.dateFormat),
                    duration: PlaylistUtility.formatTime(data.duration),
                    thumbnailUrl: thumbnailUrl,
                    viewsCount: viewsCount,
                    pluginUrl: pluginUrl,
                    launchUrl: launchUrl,
                    javascriptPluginUrl: javascriptPluginUrl,
                    isYoutube: isYoutube
                };
            },
            getFallbackThumbnail: function (callback) {
                var self = this;
                this.get(this.brandingUrl, {}, function (data) {
                    self.fallbackThumbnailUrl = data.thumbnailImageUrlTemplate;
                    callback();
                }, undefined, { 'Accept': "application/hal+json, application/json, */*; q=0.01", 'X-EV-InstitutionId': this.institutionId });
            },
            convertToUserDateTime: function (utcDateTime, timeZone, timeFormat) {
                try {
                    var localDate = moment/*.utc*/(utcDateTime)/*.tz(timeZone)*/.toDate();
                    return this.formatDateTime(localDate, timeFormat);
                } catch (e) {
                    console.log(e);

                    return utcDateTime;
                }
            },
            formatDateTime: function (dateTime, dateTimeFormat) {
                return moment(dateTime).format(dateTimeFormat);
            }
        };
    });